<div class="ai-activity" *ngIf="steps.length">
	<div class="ai-activity-step"
		 *ngFor="let step of steps"
		 [class.done]="step.state === 'done'"
		 [class.error]="step.state === 'error'">
		<span class="ai-activity-icon">
			<i *ngIf="step.state === 'running'" class="fas fa-spinner-third fa-spin"></i>
			<i *ngIf="step.state === 'done'" class="fas fa-check"></i>
			<i *ngIf="step.state === 'error'" class="fas fa-exclamation-triangle"></i>
		</span>
		<span class="ai-activity-text">{{ step.text }}</span>
	</div>
</div>
